import React from 'react';
import PropTypes from 'prop-types';

/**
 * ExitAnimation component.
 * Wraps children with enter/exit fade animation classes.
 *
 * @param {object} props - Component props.
 * @param {boolean} props.exitAnimation - When true, applies fade-up; otherwise fade-down.
 * @param {boolean} props.enabled - When false, skips animation classes on the wrapper.
 * @param {React.ReactNode} props.children - Content to animate.
 * @returns {JSX.Element} The animated wrapper.
 */
const ExitAnimation = ({ exitAnimation, enabled, children }) => {
  let className;

  if (enabled) {
    className = exitAnimation ? 'fade-up' : 'fade-down';
  }

  return <div className={className}>{children}</div>;
};

ExitAnimation.propTypes = {
  exitAnimation: PropTypes.bool,
  enabled: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ExitAnimation.defaultProps = {
  exitAnimation: false,
  enabled: true,
};

export default ExitAnimation;
